import { right } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

//TODO implement
const GetAIEmailsByCustomerApiImpl = async (query: any, type: string, params: string): Promise<any> => {
    
    const baseUrl = di.get<Constants>(ConstantsName).AI;

    // Build the URL properly
    let url = baseUrl + `/list?channel=emails`;
    
    // Add customer parameter (required as first parameter after channel)
    if (query.customer) {
        url += `&customer=${query.customer}`;
    }
    
    // Add other parameters
    if (query.lob) {
        url += `&lob=${query.lob}`;
    }
    if (query.agent) {
        url += `&user_id=${query.user_id}`;
    }
    if (query.aiEvaluated) {
        url += `&aiEvaluated=${query.aiEvaluated === "True" ? true : false}`;
    }
    if (query.manualEvaluated) {
        url += `&manualEvaluated=${query.manualEvaluated === "True" ? true : false}`;
    }
    if (query.dateInit) {
        url += `&dateFrom=${query.dateInit}`;
    }
    if (query.dateEnd) {
        url += `&dateTo=${query.dateEnd}`;
    }
    if (query.status) {
        url += `&status=${query.status}`;
    }
    if (query.hrId) {
        url += `&hrId=${query.hrId}`;
    }
    
    // Add limit if not already present in params
    if (!params || !params.includes('limit')) {
        url += `&limit=20`;
    }
    
    // Add additional parameters if they exist
    if (params && params !== "") {
        url += `&${params}`;
    }

    console.log('GetAIEmailsByCustomerApiImpl - URL:', url);
    console.log('GetAIEmailsByCustomerApiImpl - params:', params);

    const response = await callAPI(url, 'GET', {});

    const reader = response.body?.getReader();

    if (!reader) {
        throw new Error("Readable stream not supported or body is empty.");
    }
    
    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    // Decoding the last chunk
    result += decoder.decode();
    
    return right(result);
}

export default GetAIEmailsByCustomerApiImpl;
